import api from "../config";
import URLS from "../../constants/urls";
export const _userLogin = async (data) => {
    const response = await api.post(URLS.LOGIN, data);
    return response;
};
export const _getUserDetails = async () => {
    const response = await api.get(URLS.USER);
    return response;
};
export const _verifyMapExists = async (id) => {
    const response = await api.get(`${URLS.VERIFY_SITE_MAP}/${id}`);
    return response;
};
export const _createSite = async (data) => {
    const response = await api.post(URLS.CREATE_SITE, data);
    return response;
};
export const _uploadSiteImage = async ({ siteId, data }) => {
    const response = await api.post(`${URLS.UPLOAD_SITE_IMAGE}/${siteId}`, data);
    return response;
};
export const _upadteSite = async ({ siteId, data }) => {
    const response = await api.put(`${URLS.UPDATE_SITE}/${siteId}`, data);
    return response;
};
export const _getBuildings = async (siteId) => {
    const response = await api.get(`${URLS.GET_BUILDING}/${siteId}`);
    return response;
};
export const _createBuilding = async (data) => {
    const response = await api.post(`${URLS.CREATE_BUILDING}`, data);
    return response;
};
export const _createFloor = async (data) => {
    const response = await api.post(`${URLS.CREATE_FLOOR}`, data);
    return response;
};
export const _uploadFloorImage = async ({ floorId, siteId, data, }) => {
    const response = await api.post(`${URLS.UPLOAD_FLOOR_IMAGE}/${siteId}/${floorId}`, data);
    return response;
};
export const _getFloor = async ({ siteId, data }) => {
    const response = await api.get(`${URLS.GET_FLOORS}/${siteId}`, {
        params: data,
    });
    return response;
};
export const _swapFloors = async (floorId1, floorId2) => {
    const response = await api.put(URLS.SWAP_FLOOR, {
        floorId1: floorId1,
        floorId2: floorId2,
    });
    return response;
};
export const _changeBuildingName = async (buildingId, siteId, name, defaultFloorId, aligned) => {
    const response = await api.put(`${URLS.CHANGE_BUILDING_NAME}/${siteId}/${buildingId}`, {
        name: name,
        defaultFloorId: defaultFloorId,
        aligned: aligned,
    });
    return response;
};
export const _changeDefaultBuildingFloor = async (buildingId, siteId, defaultFloorId) => {
    const response = await api.put(`${URLS.CHANGE_BUILDING_NAME}/${siteId}/${buildingId}`, {
        defaultFloorId: defaultFloorId,
    });
    return response;
};
export const _setBuildingAligned = async (buildingId, siteId, aligned) => {
    const response = await api.put(`${URLS.CHANGE_BUILDING_NAME}/${siteId}/${buildingId}`, {
        aligned: aligned,
    });
    return response;
};
export const _updateFloor = async (siteId, floorId, name) => {
    const response = await api.put(`${URLS.UPDATE_FLOOR}/${siteId}/${floorId}`, {
        shortName: name,
    });
    return response;
};
export const _updateFloorData = async (siteId, floorId, data) => {
    const response = await api.put(`${URLS.UPDATE_FLOOR}/${siteId}/${floorId}`, {
        ...(data || {}),
    });
    return response;
};
export const _deleteFloor = async (siteId, floorId) => {
    const response = await api.delete(`${URLS.UPDATE_FLOOR}/${siteId}/${floorId}`);
    return response;
};
export const _deleteBuilding = async (buildingId, siteId) => {
    const response = await api.delete(`${URLS.CHANGE_BUILDING_NAME}/${siteId}/${buildingId}`);
    return response;
};
export const _updateFloorGeoreference = async (coordintes, siteId, floorId, rotation) => {
    const response = await api.put(`${URLS.UPDATE_FLOOR_GEOREFERENCE}/${siteId}/${floorId}`, {
        geoReferences: coordintes,
        rotation: rotation
    });
    return response;
};
export const _updateFloorRotation = async (rotation, siteId, floorId) => {
    const response = await api.put(`${URLS.UPDATE_FLOOR_GEOREFERENCE}/${siteId}/${floorId}`, {
        rotation: rotation,
    });
    return response;
};
export const _publishSite = async (siteId) => {
    const response = await api.put(`${URLS.PUBLISH}/${siteId}/publish`);
    return response;
};
export const _getUserOrganisations = async (data) => {
    const response = await api.post(URLS.GET_USER_ORGANISATIONS, data);
    return response;
};
export const _userLoginV2 = async (data) => {
    const response = await api.post(URLS.USER_LOGIN, data);
    return response;
};
export const _getSiteList = async (params) => {
    const response = await api.get(URLS.SITE_LIST, { params });
    return response;
};
export const _getSiteDetails = async (siteId) => {
    const response = await api.get(`${URLS.SITE_LIST}/${siteId}`);
    return response;
};
